export default "__VITE_ASSET__0558ec2f__"